import { Delete } from "@mui/icons-material";
import { Box, CircularProgress } from "@mui/material";

interface IProps {
	selectedImg: string;
	allowEdit: boolean;
	height?: number;
	loading?: boolean;
	onDelete?: () => void;
}

const ImgPreview = (props: IProps) => {
	const {
		selectedImg,
		allowEdit = false,
		height = 600,
		loading = false,
		onDelete = () => {},
	} = props;
	return (
		<Box className={"imgContainer"} sx={{ height: height }}>
			<img src={selectedImg} alt="banner.png" className={"bannerImg"} />

			{allowEdit && (
				<Box className={"deleteIcon"}>
					{loading ? (
						<CircularProgress
							sx={{ flex: 1000 }}
							size={30}
							color="primary"
						/>
					) : (
						<Delete
							className="delete-icon"
							color="primary"
							onClick={onDelete}
							fontSize="large"
						/>
					)}
				</Box>
			)}
		</Box>
	);
};

export default ImgPreview;
